module.exports = "/_next/static/media/d72bd677655578718c79b8ea57f9612d.svg";